import { render } from "./LottieAdapter.vue?vue&type=template&id=1f637c33&scoped=true"
import script from "./LottieAdapter.vue?vue&type=script&lang=js"
export * from "./LottieAdapter.vue?vue&type=script&lang=js"

import "./LottieAdapter.vue?vue&type=style&index=0&id=1f637c33&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f637c33"]])

export default __exports__